import React from "react";

import { Button, Typography, Box } from "@mui/material";

import ModernModal from "../../../common/ModernModal";
import { OrganizationUser } from "../../services/user-management.service";

interface Props {
  user: OrganizationUser;
  handleClose: () => void;
  handleConfirm: () => void;
  open: boolean;
}

export default function ConfirmUserDeleteDialog({
  user,
  handleClose,
  handleConfirm,
  open,
}: Props) {
  return (
    <ModernModal
      open={open}
      onClose={handleClose}
      title="Delete User"
      maxWidth="sm"
      actions={
        <Box sx={{ display: "flex", gap: 1.5 }}>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirm}
            sx={{
              background:
                "linear-gradient(135deg, #e53e3e, #c53030) !important",
              color: "#ffffff !important",
              fontWeight: 600,
              boxShadow: "0 4px 12px rgba(229, 62, 62, 0.3) !important",
              "&:hover": {
                background:
                  "linear-gradient(135deg, #c53030, #9c2626) !important",
                boxShadow: "0 6px 20px rgba(229, 62, 62, 0.4) !important",
                transform: "translateY(-1px)",
              },
              "&.MuiButton-contained": {
                background:
                  "linear-gradient(135deg, #e53e3e, #c53030) !important",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, #c53030, #9c2626) !important",
                },
              },
            }}
          >
            Delete User
          </Button>
        </Box>
      }
    >
      <Typography variant="body1" sx={{ mb: 2 }}>
        Are you sure you want to delete this user?
      </Typography>
      <Typography variant="body2" color="text.secondary">
        This action cannot be undone and the user{" "}
        <Typography component="span" fontWeight={600} color="text.primary">
          {user.email}
        </Typography>{" "}
        will be permanently removed from your organization.
      </Typography>
    </ModernModal>
  );
}
